import React from 'react';
import { View } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { IconProps } from '../../Icons';
import { Typography } from '../../Text';
import ListItem from './ListItem';

export type OrderTypeListItemType = {
  iconComponent?: React.ElementType;
  iconProps?: IconProps;
  subtitle: string;
  title: string;
  onPress?: () => void;
  className?: string;
};

export const OrderTypeListItem = ({
  iconComponent: IconComponent,
  iconProps,
  subtitle,
  title,
  onPress,
  className,
}: OrderTypeListItemType) => {
  return (
    <ListItem className={className} onPress={onPress} pressable>
      <View className="mr-4 justify-center">
        {IconComponent && (
          <IconComponent
            {...iconProps}
            className={twMerge(
              'stroke-prim-electric-blue group-active:stroke-white',
              iconProps?.className
            )}
          />
        )}
      </View>
      <View className="flex-1 flex-column justify-center">
        <Typography variant="callToAction" size="normal" className="text-white">
          {title}
        </Typography>
        <Typography
          weight="regular"
          variant="body"
          size="small"
          className="text-neutral-400"
        >
          {subtitle}
        </Typography>
      </View>
    </ListItem>
  );
};
